import api from '../../../../services/api';
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import PageContainer from '../../../../common/components/PageContainer';
import useAlerta from '../../../../common/components/useAlerta';
import AppSnackbar from '../../../../common/components/AppSnackbar';

function VeiculoAbastecimento() {
    const [veiculo, setVeiculo] = useState({});
    const { id } = useParams();
    const { alerta, mostrarAlerta, fecharAlerta } = useAlerta();
    const { register, handleSubmit, reset, setValue } = useForm();

    const onSubmit = async (data) => {
        const formData = { ...data };

        try {
            await api.post(`/veiculo/${id}/abastecimento`, formData);
            mostrarAlerta('Veículo abastecido com sucesso!', 'success');
            setTimeout(() => {
                window.location.href = `/veiculo/${id}`;
            }, 1500);
        } catch (error) {
            mostrarAlerta('Erro ao abastecer o veículo!', 'error');
        }
        setTimeout(fecharAlerta, 3000);
    };

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/veiculo/${id}`);
                setVeiculo(response.data);
                reset(response.data);
                const hoje = new Date().toISOString().split('T')[0];
                setValue("data", hoje);
            } catch (error) {
                console.error('Erro ao buscar o veículo:', error);
            }
        }

        fetchData();
    }, [id, reset, setValue]);

    return (
        <PageContainer sx={{ maxWidth: 700 }}>
            <Paper component="form" onSubmit={handleSubmit(onSubmit)} sx={{ p: { xs: 2, sm: 4 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                    <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 600 }}>
                        Abastecimento
                    </Typography>
                    {veiculo.foto && (
                        <Box
                            component="img"
                            src={`data:image/jpeg;base64,${veiculo.foto}`}
                            alt="Veículo"
                            sx={{ height: 40, borderRadius: 1 }}
                        />
                    )}
                </Box>

                <Grid container spacing={2}>
                    <Grid item xs={6} sm={3}>
                        <TextField {...register("litros")} label="Litros" type="number" required fullWidth InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <TextField {...register("valor")} label="Valor" type="number" required fullWidth InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <TextField {...register("km")} label="KM" type="number" required fullWidth InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <TextField {...register("horimetro")} label="Horímetro" type="number" required fullWidth InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField {...register("data")} label="Data do abastecimento" type="date" InputLabelProps={{ shrink: true }} required fullWidth />
                    </Grid>
                </Grid>

                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <Button type="submit" variant="contained" color="secondary" size="large" sx={{ px: 6 }}>
                        Abastecer
                    </Button>
                </Box>
            </Paper>

            <AppSnackbar alerta={alerta} onClose={fecharAlerta} />
        </PageContainer>
    );
}

export default VeiculoAbastecimento;
